import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface StorageState {
  uri: unknown
  container: unknown
  sas: unknown
}

const initialState: StorageState = {
  uri: undefined,
  container: undefined,
  sas: undefined,
}

const storageSlice = createSlice({
  name: 'storage',
  initialState,
  reducers: {
    uri(state, action: PayloadAction<unknown>) {
      state.uri = action.payload
    },
    container(state, action: PayloadAction<unknown>) {
      state.container = action.payload
    },
    sas(state, action: PayloadAction<unknown>) {
      state.sas = action.payload
    },
    registerStorage(
      state,
      action: PayloadAction<{ uri: unknown; container: unknown; sas: unknown }>,
    ) {
      state.uri = action.payload.uri
      state.container = action.payload.container
      state.sas = action.payload.sas
    },
    unregisterStorage(state) {
      state.uri = undefined
      state.container = undefined
      state.sas = undefined
    },
  },
})

export const { uri, container, sas, registerStorage, unregisterStorage } =
  storageSlice.actions

export const selectIsStorageRegistered = (state: { storage: StorageState }) =>
  state.storage.uri !== undefined &&
  state.storage.container !== undefined &&
  state.storage.sas !== undefined

export default storageSlice.reducer
